import { auth } from './auth'
import { database } from '../database'

/**
 * Register self user
 *
 * @param {string} email
 * @param {string} password
 * @param {Object} userData
 * @param {string} userData.name
 * @param {string} userData.surname
 * @param {boolean} userData.approved
 * @param {boolean} userData.defaultPasswordChanged
 * @param {string} userData.company
 *
 * @return {Promise<void>}
 */
export const register = (email, password, userData) => (
    auth().createUserWithEmailAndPassword(email, password)
        .then(() => {
            const user = auth().currentUser

            const {
                name,
                surname,
                company,
                isSuperAdmin,
            } = userData

            const updateProfile = user.updateProfile({
                displayName: `${name} ${surname}`,
            })

            const setDatabaseData = database('user')
                .doc(user.uid)
                .set({
                    uid: user.uid,
                    name: name,
                    surname: surname,
                    approved: false,
                    defaultPasswordChanged: false,
                    company: company || '',
                    superAdmin: isSuperAdmin || false,
                })

            return Promise.all([ updateProfile, setDatabaseData ])
        })
        .catch(err => console.error('err', err))
)
